import { useModalContentToggler } from '@components'

import { Button, ButtonsGroup, Space, Text } from '@billy/design-system'
import { ReactElement, useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useInitiateOpenBankingConnection } from '@features/openBanking/hooks/useInitiateOpenBankingConnection'

import { BankReconciliationConnectBank } from '../../../../../../../../assets/images'
import { useSegment } from '../../../../../../../../hooks'
import { useBankLines, usePaymentModal } from '../../../../../../../paymentReconciliationModal/contexts'
import { BankLinesState } from '../../../../../../enums'
import { SubjectReconciliationModalStateId } from '../../../../../../enums/SubjectReconciliationModalStateId'
import * as Styled from '../styles'

export const ConnectBank = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()

  const { setActiveState } = useModalContentToggler()
  const { selectedAccountId } = usePaymentModal()
  const { bankLines, setBankLinesState, setIsPromptHidden } = useBankLines()
  const { isProcessing: isAiiaInitiating } = useInitiateOpenBankingConnection()

  const handleConnectBankButtonClick = useCallback(() => {
    track('xxx - expenses - Bank line modal - connect bank button clicked')

    if (!selectedAccountId) {
      return
    }

    setActiveState(SubjectReconciliationModalStateId.ConnectBank)
  }, [selectedAccountId, setActiveState, track])

  const handleSkipButtonClick = useCallback(() => {
    track('xxx - expenses - Bank line modal - skip bank connection button clicked')
    setIsPromptHidden(true)

    if (!bankLines?.length) {
      setBankLinesState(BankLinesState.Empty)
      return
    }

    setBankLinesState(BankLinesState.BankLinesList)
  }, [bankLines?.length, setBankLinesState, setIsPromptHidden, track])

  useEffect(() => {
    track('xxx - expenses - Bank line modal - connect bank button shown')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Styled.EmptyStateWrapper>
      <Styled.IllustrationContainer>
        <BankReconciliationConnectBank />
      </Styled.IllustrationContainer>
      <Space size="s8" />
      <Text variant="h4" alignment="center">
        {t('bill.payment_reconcile.connect_your_bank')}
      </Text>
      <Space size="s8" />
      <Text alignment="center">{t('empty_state.bank_not_connected.description')}</Text>
      <Space />
      <ButtonsGroup>
        <Button onClick={handleSkipButtonClick} disabled={isAiiaInitiating} variant="text">
          {t('skip')}
        </Button>
        <Button onClick={handleConnectBankButtonClick} icon="bank">
          {t('connect_bank')}
        </Button>
      </ButtonsGroup>
    </Styled.EmptyStateWrapper>
  )
}
